module.exports = __webpack_public_path__ + "img/recruitment_logo.b4bdb1f4.jpeg";